export interface AccessToken {
    accessToken: string;
    expiresAt: Date;
    refreshToken: string;
    refreshExpiresAt: Date;
}

export function toAccessToken(token: any): AccessToken | null {
    if (!token) {
        return null;
    }
    if (typeof token != 'object') {
        token = JSON.parse(token);
    }
    if (
        'access_token' in token && typeof token.access_token === 'string' &&
        'refresh_token' in token  && typeof token.refresh_token === 'string' &&
        'expires_at' in token  && typeof token.expires_at === 'string' &&
        'refresh_expires_at' in token  && typeof token.refresh_expires_at === 'string'
    ) {
        const accessToken: AccessToken = {
            accessToken: token.access_token,
            refreshToken: token.refresh_token,
            expiresAt: new Date(token.expires_at),
            refreshExpiresAt: new Date(token.refresh_expires_at)
        };
        return accessToken;
    }

    return null;
}